export default __webpack_public_path__ + "static/media/MintBG.35176858.png";